import React from "react";

interface LoadingSpinnerProps {
  size?: "small" | "medium" | "large";
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = "medium" }) => {
  const sizeClasses = {
    small: "h-5 w-5",
    medium: "h-6 w-6",
    large: "h-8 w-8",
  };

  return (
    <div
      className={`border-t-transparent animate-spin rounded-full border-2 border-brand-500 ${sizeClasses[size]}`}
    />
  );
};

export default LoadingSpinner;
